// extracted by mini-css-extract-plugin
export default {"surface-box":"d0db85"};